import { css as r } from "@microsoft/fast-element";
import { normalize as n } from "../common/normalize.js";
import { display as a } from "@matrix42/fast-foundation";
import { typography as e } from "../styles/typography.js";
import { designTokens as o } from "../design-tokens.js";
const g = (i) => r`
  ${n}
  ${a("flex")}
  .container {
    display: flex;
    flex-direction: column;
    gap: ${o.spacing[2]};
    position: relative;
  }

  .control {
    display: flex;
    border: ${o.borderWidth.xs} solid
      ${o.color.neutral[60]};
    border-radius: ${o.borderRadius.md};
    color: ${o.color.neutral[500]};
    /* Typography */
    ${e("label", "regular")}
    overflow: clip;
  }

  .chip-ai-variant {
    display: flex;
    align-items: center;
    gap: ${o.spacing[1]};
  }

  ${i.prefix}-icon {
    color: ${o.color.neutral[90]};
    height: ${o.iconSize.xs} !important;
    width: ${o.iconSize.xs} !important;
  }

  .suggestion,
  .dismiss {
    display: flex;
    align-items: center;
    padding: ${o.spacing[2]};
    user-select: none;
    cursor: pointer;
  }

  .suggestion:hover,
  .dismiss:hover {
    background-color: ${o.color.neutral[40]};
  }

  .suggestion:active,
  .dismiss:active {
    background-color: ${o.color.neutral[60]};
  }

  .suggestion {
    gap: ${o.spacing[2]};
    border-right: 1px solid ${o.color.neutral[60]};
    flex: 1 0 0;
  }

  .suggestion-value {
    ${e("label", "regular")}
    display: flex;
    flex: 1 0 0;
  }

  .chip-action-more {
    border-radius: ${o.spacing[3]};
    background: ${o.color.neutral[50]};
    display: flex;
    padding: ${o.spacing[2]};
    justify-content: center;
    align-items: center;
    gap: 8px;
    height: 32px;
    cursor: pointer;
  }

  .chip-action-more:hover {
    background: ${o.color.neutral[60]};
  }
  .chip-action-more:active {
    background: ${o.color.neutral[70]};
  }

  .info-text {
    display: flex;
    padding: ${o.spacing[1]} ${o.spacing[2]};
    align-items: center;
    gap: 8px;
    align-self: stretch;
    color: ${o.color.neutral[80]} solid;
    pointer: cursor;
  }

  .info-text > p {
    ${e("label", "regular")}
    color:${o.color.neutral[80]};
  }

  .drop-menu {
    display: flex;
    width: ${o.spacing[64]};
    flex-direction: column;
    align-items: flex-start;
    border-radius: ${o.spacing[3]};
    border: 1px ${o.color.neutral[60]} solid;
    position: absolute;
    top: 100%;
    margin-top: 0.313rem;
  }

  .drop-menu.collapsed {
    opacity: 0;
    max-height: 0;
    pointer-events: none;
  }

  .drop-menu.expanded {
    max-height: 500px;
    padding: ${o.spacing[2]} 0px;
    background: ${o.color.white};
    z-index: 1;
  }

  .chip-menu-item {
    display: flex;
    width: ${o.spacing[64]};
    padding: ${o.spacing[2]};
    align-items: center;
    gap: ${o.spacing[2]};
    cursor: pointer;
  }
  .chip-menu-item:hover {
    background: ${o.color.neutral[40]};
  }

  p {
    ${e("label", "regular")}
    margin: 0;
  }
`;
export {
  g as aiChipStyles
};
